<template>
  <div class="container-fluid mt-2">
    <h2>Aufgabe: {{ task.name }}</h2>
    <p>{{ task.desc }}</p>
    <div class="row mt-2">
      <div v-if="external" class="col-md justify-content-center">
        <a :href="formlink"><button class="btn btn-primary">Formular öffnen</button></a>
      </div>
      <div v-if="!external" class="col-md">
        <h4>Ihre Angaben</h4>
        <div class="btn-toolbar mb-3">
          <button @click="submitForm" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Absenden</button>
        </div>
        <TaskForm ref="taskform" :props="task.properties" :custprops="custprops"/>
        <small v-if="task.task" class="form-text text-muted">{{ task.task.created }}</small>
      </div>
      <div class="col-md">
        <h4>Informationen</h4>
        <b-tabs v-model="tabidx">
          <b-tab title="Vorschau">
            <DynamicDataView :html="preview" :data="task"/>
          </b-tab>
          <b-tab title="Daten">
            <JsonViewer :data="task.values" :root="true"/>
          </b-tab>
          <b-tab title="Hilfe">
            <div v-html="help" class="wrapper mt-2">
            </div>
          </b-tab>
          <b-tab title="Prozess">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td>Start:</td><td>{{ history.start }}</td>
                </tr>
                <tr>
                  <td>Prozess:</td><td>{{ history.key }}</td>
                </tr>
                <tr>
                  <td>Prozess-ID:</td><td>{{ history.id }}</td>
                </tr>
              </tbody>
            </table>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import router from '@/router'
import workflows from '@/modules/workflows.js'
import services from '@/modules/services.js'
import JsonViewer from '@/components/JsonViewer.vue'
import DynamicDataView from '@/components/DynamicDataView.vue'
import TaskForm from '@/components/digitalfirm/workflows/TaskForm.vue'

export default {
  name: 'TaskFormView',
  components: {
    JsonViewer,
    TaskForm,
    DynamicDataView,
  },
  data() {
    return {
      tabidx: 2,
      help: 'Kein Hilfstext gefunden.',
      formlink: '#',
      custprops: {},
      external: true,
      taskid: 0,
      task: {},
      history: {},
      preview: '',
    }
  },
  created: function() {
    this.taskid = this.$route.params.taskid;
    var self = this;
    services.loadtaskform(this,this.taskid,function(data) {
      if (data.properties) {
        var temp = {};
        for (var idx in data.properties) {
          var p = data.properties[idx];
          temp[p.pid] = {};
        }
        self.custprops = temp;
      }
      self.task = data;
      self.checkPreview();
    })
  },
  methods: {
    checkExternForm() {
      var self = this;
      workflows.loadformlink(this,this.history.key + '_' + this.task.task.tid,function(data) {
        if (!data || _.isEmpty(data)) {
          self.external = false;
          return;
        }
        var temp = JSON.parse(JSON.stringify(self.custprops));
        for (var idx in data.properties) {
          var p = data.properties[idx];
          temp[idx] = p;
        }
        self.custprops = temp;
        if (data.help) {
          self.help = data.help;
        }
        //self.$refs.taskform.$forceUpdate();
        self.external = false;
      });
    },
    checkPreview: function() {
      console.log(JSON.stringify(this.task.task.procid));
      var self = this;
      workflows.historyEntry(this,this.task.task.procid,function(data) {
        self.history = data;
        self.checkExternForm();
        if (data.key) {
          workflows.loadresultpreview(this,data.key,function(data) {
            console.log(data);
            self.preview = data.html;
            self.tabidx = 0;
          })
        }
      })
    },
    submitForm: function() {
      var data  = this.$refs.taskform.readValues(true);
      console.log(data);
      if (!confirm('Sind Ihre Angaben alle korrekt?')) {
        return;
      }
      var self = this;
      services.submittaskform(this,this.taskid,data,function() {
        self.$bvToast.toast('Angaben übermittelt',{title: 'Aufgaben',variant:'success'})
        router.push({name: 'TaskList'});
      })
    }
  }
}
</script>
